const s = (e) => e.userData.isDetailedMesh;
export {
  s as isDetailedMesh
};
//# sourceMappingURL=index.js.map
